import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { sortDDLByLabel, useNavigateToLogout } from "../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { CityInfoSetupFieldsPanel } from "./Panels/CityInfoSetupFieldsPanel";
import { CityService } from "../../services/CityService";
import { CitySetupToolbar } from "./CitySetupToolbar/CitySetupToolbar";
import { CitySetupValidationSchema } from "./validator";
import { CountryService } from "../../services/common/CountryService";
import { DDLDataTable } from "../DDLDataTable";
import { EnhancedButtonPrimeReact } from "../EnhancedButtonPrimeReact";
import { IAppState } from "../../store/reducers";
import { ICity } from "../../models/City";
import { IGetListRequest } from "../../models";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";






export interface ICitySetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "city-single-data-record";
const DEPARTMENTS_LIST_DATA_QUERY_KEY = "city-list";

const useGetData = (
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id, navigateToLogout],
		queryFn: () => {
			return CityService.getById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useCity = (
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY, params],
		queryFn: (data) => {

			return CityService.getCity(params, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: (data) => {
			return CountryService.getCountryDDL();
		},
		refetchOnWindowFocus: false,
	});
export const CitySetup: React.FC<ICitySetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [provinceId, setProvinceId] = useState<any>("all");
	const [cityId, setCityId] = useState<number | string>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [provinceDDLLoading, setProvinceDDLLoading] = useState(false);
	const [provinceDDLItems, setProvinceDDLItems] = useState<any>(undefined);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null ? requestParams.sortField : "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending, data } = useCity(queryParams, navigateToLogout);

	const cityList: any | null = data;

	const onProvinceSelectionChangeHandler = (selected: any) => {
		setProvinceId(selected.value)
	}

	const { isPending: isSubmitting, mutate: submitCityFormFields } = useMutation(
		{
			mutationFn: CityService.create,
			onSuccess: (res: ICity | IServerError | IResponse | any) => {

				if (res.status === 200) {
					// if (instanceOfICityResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/city/${res.data.id}`;
					navigate(path);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else if (res.status === 201) {
					// if (instanceOfICityResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/city/${res.data.id}`;
					navigate(path);
					setEditRecordId(res.data.id);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
						}),
					]);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		}
	);

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		editRecordId,
		navigateToLogout
	);

	const upadtedCityListItems = useMemo(() => {
		return (
			cityList &&
			cityList.items &&
			cityList?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/city/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{item.name}
					</Link>
				),
			}))
		);
	}, [cityList]);

	const { isPending: isPendingCountryDDL, data: countryList } =
		useGetCountryDDL();

	const DEFAULT_VALUES = {
		provinceState: undefined,
		name: undefined,
	};
	const formMethods = useForm<any>({
		resolver: yupResolver(CitySetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES,
	});

	const onSubmit = (values: any) => {

		const selectedProvinceOrState = values.provinceState
			? provinceDDLItems.find((e: any) => e.value === values.provinceState)
			: values.state
				? provinceDDLItems.find((e: any) => e.value === values.provinceState)
				: undefined;

		let payload = {
			id: id && id,
			navigateToLogout: navigateToLogout,
			name: values.name,
			provinceState: {
				id: selectedProvinceOrState.value,
				name: selectedProvinceOrState.label,
				shortCode: selectedProvinceOrState.shortCode,
			},
		};
		submitCityFormFields(payload);
	};

	useEffect(() => {
		if (id && selectedDataRecord) {

			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (typeof fieldValue !== "object") {
					// @ts-ignore
					formMethods.setValue(fieldName, fieldValue ?? undefined);
				} else if (fieldValue !== null || undefined) {
					// @ts-ignore
					formMethods.setValue(fieldName, fieldValue.id ?? undefined);
					// setSelectedProvince(fieldValue);
				}
			});
		}
	}, [id, selectedDataRecord]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteCityById } = useMutation({
		mutationFn: CityService.delCity,
		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the City fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/city`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteCityField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				cityId: cityId,
				navigateToLogout: navigateToLogout,
			};
			deleteCityById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setCityId(selectedDataRecord.id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setCityId(params.id);
	}, []);

	const { isPending: isArchive, mutate: archiveCityById } = useMutation({
		mutationFn: CityService.archiveCity,
		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the City fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/city`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const archiveCityField = () => {
		if (singleArchive) {
			setSingleArchive(false);
			let ArchivePayload = {
				cityId: cityId,
				navigateToLogout: navigateToLogout,
			};
			archiveCityById(ArchivePayload);
			setArchiveDialogOpen(false);
		}
	};

	const onArchiveClicked = () => {
		setArchiveDialogOpen(true);
		setSingleArchive(true);
		if (selectedDataRecord) {
			setCityId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		let path = `/city`;
		navigate(path);
	};

	const expandedLabels = ["Misc.", "City"];
	const expandedCitySetupOrSetupItem = "City"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Misc." &&
				item.label === expandedCitySetupOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedCitySetupOrSetupItem && "/city",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		// dispatch(
		// 	setSelectedActivityLogActions({
		// 		entityId1: "",
		// 		entityId2: "",
		// 		entityId3: "",
		// 		screenName: ACCOUNTANT_SETUP_SCREEN_SLUG,
		// 		name: "",
		// 		activityType:
		// 			"activity_type=create&activity_type=updated&activity_type=delete",
		// 		activityLogVisibility: true,
		// 	})
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onRowEditClicked = useCallback((params: ICity | any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/city/${params.value}`;
		navigate(path);
	}, []);

	return (
		<Grid
		// sx={{
		// 	pb: "5rem",
		// 	"& .MuiAppBar-root": {
		// 		zIndex: 2,
		// 		top: subMenuVisibility ? "154px" : "112px",
		// 	},
		// }}
		>
			<BackdropCircularProgress
				open={
					isSubmitting ||
					isPendingById ||
					isDeleting ||
					isArchive ||
					provinceDDLLoading
				}
				testId="comapny Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteCityField}
				cancelActionHandler={onCloseHandler}
				testId="city-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 3.5, lg: 3.5, xl: 3.5 }}>
							<SingleColumnLayout
								children={
									<StandardPanel
										title="City"
										testId={`city`}
										showTitle={false}
										variant="outlined"
										topPadding={2}
									>
										<CityInfoSetupFieldsPanel
											countryList={countryList && sortDDLByLabel(countryList)}
											formMethods={formMethods}
											provinceDDLLoading={(value: boolean) =>
												setProvinceDDLLoading(value)
											}
											// provinceStateLabelinUpdate={
											// 	provinceStateLabelinUpdate && provinceStateLabelinUpdate
											// }
											// provinceStateDDLinUpdate={
											// 	provinceStateDDLinUpdate && provinceStateDDLinUpdate
											// }
											provinceDDLItems={(value: any) =>
												setProvinceDDLItems(value)
											}
											onProvinceSelectionChangeHandler={onProvinceSelectionChangeHandler}
										/>
									</StandardPanel>
								}
								toolbar={
									<CitySetupToolbar
										onResetClicked={onResetClicked}
										onDeleteClicked={onDeleteClicked}
										isSubmitting={false}
										id={id}
									/>
								}
								toolbarPosition="bottom"
								showFullDiaplay={true}
								testId="form-layout"
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 3, lg: 3, xl: 3 }}></Grid>
						<Grid
							size={{ xs: 12, sm: 12, md: 5.5, lg: 5.5, xl: 5.5 }}
							sx={{ marginTop: "16px" }}
						>
							<DDLDataTable
								rows={
									cityList && upadtedCityListItems ? upadtedCityListItems : []
								}
								columns={[
									{ field: "label", headerName: "City Name" },
									{ field: "provinceName", headerName: "Province Name" },
								]}
								showHeaderColumns={true}
								onRowEditClicked={onRowEditClicked}
								onRowDeleteClicked={onRowDeleteClicked}
								onRowArchiveClicked={onArchiveClicked}
								isLoading={isPending}
								totalRecords={cityList && cityList.total ? cityList.total : 0}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"60vh"}
								selectedId={selectedDataRecord && id && selectedDataRecord.id}
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
					</Grid>
				</form>
			</FormProvider>

			{/* Archive Dialogue */}
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseArchiveHandler}
				open={openArchiveDialog}
				dialogContent={null}
				// showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseArchiveHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Archive"
							severity="secondary"
							raised
							onClickHandler={() => archiveCityField}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"city-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
